module.exports = __webpack_public_path__ + "img/qiqiu3.6fc8a888.png";